import { PRODUCT_NAMES } from './product-names.js';
import { OpsDeviceCategorySchema } from '../schemas.js';
export const DEVICE_SKU_CATALOG = {
    'efem-gateway': {
        sku: 'CN-AXN-100',
        productName: PRODUCT_NAMES.AXON,
        description: 'Edge PC for EFEM robot, wafer-ID camera, and barcode integration',
    },
    'location-gateway': {
        sku: 'CN-MTX-100',
        productName: PRODUCT_NAMES.MATRIX,
        description: 'UWB positioning engine edge PC',
    },
    'location-tag': {
        sku: 'CN-NOD-UWB-01',
        productName: PRODUCT_NAMES.NODE,
        description: 'Mobile UWB node for FOUP / carrier tracking',
    },
    'location-anchor': {
        sku: 'CN-SAT-UWB-01',
        productName: PRODUCT_NAMES.SATELLITE,
        description: 'Fixed UWB reference unit',
    },
    'barcode-scanner': {
        sku: 'CN-AXN-P-BC-F-01',
        productName: PRODUCT_NAMES.AXON_BARCODE_MODULE,
        description: 'Fixed load-port barcode module for Axon (rev 01)',
    },
    'handheld-barcode-scanner': {
        sku: 'CN-AXN-P-BC-H-01',
        productName: PRODUCT_NAMES.AXON_HANDHELD_BARCODE,
        description: 'Handheld barcode module for Axon EFEM island (rev 01)',
    },
    'waferid-camera': {
        sku: 'CN-AXN-P-WID',
        productName: PRODUCT_NAMES.AXON_WAFER_ID_MODULE,
        description: 'Wafer ID imaging module for Axon (CCI Vision)',
    },
};
export function getDeviceSkuCatalogEntry(category) {
    if (!category)
        return null;
    const parsed = OpsDeviceCategorySchema.safeParse(category);
    if (!parsed.success)
        return null;
    return DEVICE_SKU_CATALOG[parsed.data];
}
export function buildOrderLineItem(deviceCategory, quantity) {
    const entry = DEVICE_SKU_CATALOG[deviceCategory];
    return {
        deviceCategory,
        sku: entry.sku,
        productName: entry.productName,
        quantity,
    };
}
export function formatOrderLineItemLabel(item) {
    return `${item.sku} · ${item.productName}`;
}
export function formatOrderLineItemSummary(item) {
    return `${formatOrderLineItemLabel(item)} × ${item.quantity}`;
}
/** Stripe / invoice line descriptions keyed by internal resource or feature id. */
export function formatBillingLineDescription(resourceKey, suffix) {
    const base = (() => {
        switch (resourceKey) {
            case 'base':
            case 'base_subscription':
                return 'CCI Operations';
            case 'axon_gateways':
                return 'Axon Gateways';
            case 'spatial_uwb':
                return 'CCI Spatial';
            case 'storage_overage':
                return 'Storage Overage';
            case 'additional_users':
                return 'Additional Users';
            case 'wafer_processing':
                return 'Wafer Processing';
            default:
                return resourceKey.replace(/_/g, ' ');
        }
    })();
    return suffix ? `${base} — ${suffix}` : base;
}
//# sourceMappingURL=sku-catalog.js.map